module.exports = __webpack_public_path__ + "media/icons/facebook-6c3ddfa0.svg";